import { z } from 'zod';
import { EmailValidation } from 'shared/validation/validationTemplates';

export const EnterEmailFormValidation = EmailValidation;

export type TEnterEmailFormType = z.infer<typeof EnterEmailFormValidation>;
